module.exports = __webpack_public_path__ + "static/media/WI3@2x.096b4f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/WI/WI3@2x.png
// module id = 741
// module chunks = 0